var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollapseContent = function SvgCollapseContent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15H6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 5 14q0-.424.287-.713A.97.97 0 0 1 6 13h4q.424 0 .713.287.287.288.287.713v4q0 .424-.287.712A.97.97 0 0 1 10 19a.97.97 0 0 1-.713-.288A.97.97 0 0 1 9 18zm6-6h3q.424 0 .712.287Q19 9.576 19 10q0 .424-.288.713A.97.97 0 0 1 18 11h-4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 13 10V6q0-.424.287-.713A.97.97 0 0 1 14 5q.424 0 .713.287Q15 5.576 15 6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollapseContent);
export { ForwardRef as ReactComponent };